module.exports = __webpack_public_path__ + "img/distinctions/image-05.jpg";